import MockTranslationsENUS from './translations-en-us';
import MockTranslationsHIIN from './translations-hi-in';
import Locales from '../../constants/locales';

export const getTranslationsBasedOnLanguageCode = (languageCode) => {
  let translations = {};

  switch (languageCode) {
    case Locales.EN_IN:
    case Locales.EN_US:
      translations = MockTranslationsENUS;
      break;

    case Locales.HI_IN:
      translations = MockTranslationsHIIN;
      break;

    default:
      // Don't put conditions based on default.
      translations = MockTranslationsENUS;
      break;
  }

  return { response: { data: translations, status: 1 } };
};
